/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_5_QInputs */

const en_vc_faq_5_q = /** @type {(inputs: Vc_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is VectorCraft the same as DrawCraft?`)
};

const zh_vc_faq_5_q = /** @type {(inputs: Vc_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 和 DrawCraft 是同一个软件吗？`)
};

/**
* | output |
* | --- |
* | "Is VectorCraft the same as DrawCraft?" |
*
* @param {Vc_Faq_5_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_5_q = /** @type {((inputs?: Vc_Faq_5_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_5_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_5_q(inputs)
	return zh_vc_faq_5_q(inputs)
});
export { vc_faq_5_q as "vc.faq.5.q" }